/* eslint-disable no-console */
import { browserHistory } from 'react-router';
import AppStore from '../../redux/store/AppStore';
import RestBuilder from '../../rest/RestBuilder';
import SubmitLoginService from '../../services/SubmitLoginService';
import FetchMyAccountService from '../../services/FetchMyAccountService';
import MyAccountActionType from '../../common/MyAccountActionType';
import PlansActionType from '../../common/PlansActionType';
import SignupPaymentActionType from '../../common/SignupPaymentActionType';
import LoginSessionHandler from '../../common/LoginSessionHandler';
import SubmitUpdatePaymentService from '../../services/SubmitUpdatePaymentService';
import SubmitPayNowService from '../../services/SubmitPayNowService';
import HomeAction from './HomeAction';
import BestPlansService from '../../services/BestPlansService';
import RestFactory from '../../rest/RestFactory';
import RestService from '../../services/RestService';
import LogoutAction from './LogoutAction';

const fetchCustomerInfo = () => (dispatch) => {
  const rest = RestFactory.getDefaultRest();
  // Return a Promise
  return FetchMyAccountService.getCustomerInfo(rest).then(
    (response) => {
      dispatch({ type: MyAccountActionType.STORE_CUSTOMER_INFO, customerInfo: response.entity });
    },
    (error) => {
      // Rethrow so returned Promise is rejected
      console.error(error);
      throw error;
    }
  );
};

const fetchPlans = tui => (dispatch) => {
  BestPlansService.getBestPlans(tui).then(
    (response) => {
      const plans = BestPlansService.getPlanData(response.entity).plans;
      dispatch({ type: PlansActionType.STORE_PLAN_DATA, plans });
      // dispatch({ type: MyAccountActionType.STORE_AVAILABLE_PLANS, plans });
    },
    (error) => {
      dispatch(HomeAction.storeError(error));
    }
  );
};

const resetPlanData = () => (dispatch) => {
  dispatch({ type: PlansActionType.RESET_ALL });
};

const fetchPlanData = (tui, samId, dispatch) => {
  BestPlansService.getBestPlans(tui, samId).then(
    (response) => {
      const plans = BestPlansService.getPlanData(response.entity).plans;
      dispatch({ type: PlansActionType.STORE_PLAN_DATA, plans });
    },
    (error) => {
      dispatch(HomeAction.storeError(error));
    }
  );
};

/**
 * Get customer data or log customer out if session has expired.
 * @returns {function(*=): *}
 */
const checkSession = () =>
  dispatch => dispatch(fetchCustomerInfo()).then(() => {
    // Session still active, load available plans for the logged in customer
    const state = AppStore.getState();
    const fetched = state.plans.fetched;
    const tui = state.myAccount.customerInfo.tui;
    const samId = state.myAccount.customerInfo.samId;
    if ((tui || samId) && !fetched) {
      fetchPlanData(tui, samId, dispatch);
    }
  }, (error) => {
    // Log user out if no longer authenticated
    if (error.status.code === 401 || error.status.code === 403) {
      LogoutAction.logout(dispatch, error);
    } else {
      dispatch(HomeAction.storeError(error));
    }
    throw error;
  });


const checkSessionActive = () => (dispatch) => {
  RestService.get('/api/v1/account/checkSession').then(
    () => {
    },
    (error) => {
      LogoutAction.logout(dispatch, error);
    }
  );
};

const submitLogin = (email, password, successCallback, failureCallback) =>
  (dispatch) => {
    dispatch({ type: PlansActionType.RESET_ALL });
    const rest = RestFactory.getDefaultRest();

    const submitLoginService = new SubmitLoginService(rest);
    submitLoginService.request(email, password).then(
      (response) => {
        if (!response.entity.authenticated) {
          failureCallback();
          return;
        }
        dispatch({ type: MyAccountActionType.SET_LOG_IN, loggedIn: response.entity.authenticated });
        LoginSessionHandler.logIn();
        successCallback();
        browserHistory.push('/dashboard');
      },
      () => {
        dispatch({ type: MyAccountActionType.RESET_ALL });
        LoginSessionHandler.clear();
        failureCallback();
      }
    );
  };

// const submitUpdatePayment = zuoraCallbackData =>
//   (dispatch) => {
//     const rest = RestFactory.getDefaultRest();
//     const submitUpdatePaymentService = new SubmitUpdatePaymentService(rest);
//     console.log('submitUpdatePayment');
//     const a = 1;
//     const b = 2;
//     if (b > a) {
//       return null;
//     }

//     return submitUpdatePaymentService.request(zuoraCallbackData.refId).then(
//       () => {
//         dispatch({ type: MyAccountActionType.STORE_UPDATE_PAYMENT_SUCCESS });
//         dispatch({ type: ZuoraActionType.DISABLE_SUBMIT, submitDisabled: true });
//         browserHistory.push('/dashboard');
//       },
//       () => {
//         // TODO somehow make this not gross
//         if (window.submitFail) {
//           window.submitFail({ genericError: 'Couldn&#39;t update payment details' });
//         }
//       }
//     );
//   };
const submitUpdatePayment = clickDetails =>
  (dispatch) => {
    const rest = RestFactory.getDefaultRest();
    const submitUpdatePaymentService = new SubmitUpdatePaymentService(rest);
    return submitUpdatePaymentService.request(clickDetails.clickSessionId, clickDetails).then(
      () => {
        dispatch({ type: MyAccountActionType.STORE_UPDATE_PAYMENT_SUCCESS });
        // dispatch({ type: ZuoraActionType.DISABLE_SUBMIT, submitDisabled: true });
        browserHistory.push('/dashboard');
      },
      () => {
        // TODO somehow make this not gross
        dispatch({ type: SignupPaymentActionType.CLICK_ERROR_MESSAGE_UPDATE,
          clickErrorStatus: {
            error: true,
            errorMessage: 'Couldn\'t update payment details'
          } });
      }
    );
  };

const clearAllDashboardNotifications = () =>
  ({ type: MyAccountActionType.CLEAR_ALL_DASHBOARD_NOTIFICATIONS });

const submitPayNow = () =>
  (dispatch) => {
    dispatch({ type: MyAccountActionType.CLEAR_ALL_DASHBOARD_NOTIFICATIONS });
    const rest = new RestBuilder().mimeJson().successCodes([200]).build();
    const submitPayNowService = new SubmitPayNowService(rest);
    return submitPayNowService.request().then(
      (response) => {
        if (response.entity.success) {
          dispatch({ type: MyAccountActionType.STORE_PAY_NOW_SUCCESS });
          browserHistory.push('/dashboard');
        } else {
          const payNowError = response.entity.reasons.pop().message;
          dispatch({ type: MyAccountActionType.STORE_PAY_NOW_ERROR, payNowError });
        }
      },
      () => {
        dispatch({ type: MyAccountActionType.STORE_PAY_NOW_ERROR, payNowError: 'We were unable to take your payment' });
      }
    );
  };

const sendChange = entity =>
  (dispatch) => {
    const rest = RestFactory.getDefaultRest();
    // Return a Promise
    return FetchMyAccountService.sendChange(rest, entity).then(
      (response) => {
        console.log(`SUCCESS sendChange response: ${JSON.stringify(response)}`);
        // dispatch(fetchCustomerInfo()).then(() => {
        browserHistory.push('/dashboard');
        // });
      },
      (error) => {
        console.error(`ERROR sendChange error: ${JSON.stringify(error)}`);
        dispatch(HomeAction.storeError(error));
      }
    );
  };

const MyAccountAction = {
  fetchCustomerInfo,
  fetchPlans,
  checkSessionActive,
  checkSession,
  resetPlanData,
  submitLogin,
  submitUpdatePayment,
  clearAllDashboardNotifications,
  submitPayNow,
  sendChange
};

export default MyAccountAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/MyAccountAction.js
 **/